window.Products.Clothing.LooseTankTopRegular = function() {};

window.Products.Clothing.LooseTankTopRegular.inherits(window.Products.Clothing.LooseTankTop);
window.Products.Clothing.LooseTankTopRegular.has_3d = true;
window.Products.Clothing.LooseTankTopRegular.id = '64-regular';
window.Products.Clothing.LooseTankTopRegular.saveId = 64;
window.Products.Clothing.LooseTankTopRegular.slug = 'loose-tank-top-regular';
window.Products.Clothing.LooseTankTopRegular.dpi = 150;